/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'logo-half-eet': {
    width: 164,
    height: 63,
    viewBox: '0 0 164 63',
    data: '<path pid="0" d="M26.1 9.4c15 0 25.2 11.3 25.2 27.7V40H13.9c.8 6.4 5.9 11.7 14.5 11.7 4.7 0 10.2-1.9 13.5-5l5.8 8.6c-5.1 4.7-12.9 7-20.8 7C11.6 62.3 0 52 0 35.8.1 21.2 10.8 9.4 26.1 9.4zm58.3 0c15 0 25.2 11.3 25.2 27.7V40H72.2c.8 6.4 5.9 11.7 14.5 11.7 4.7 0 10.2-1.9 13.5-5l5.8 8.6c-5.1 4.7-12.9 7-20.8 7-15.3 0-26.9-10.3-26.9-26.5.1-14.6 10.8-26.4 26.1-26.4zM129.6 0v22h19.7v9.1h-19.7v8.2c0 5.8 5.9 11.6 14.4 11.6 4.465 0 9.777-1.79 13.012-4.73l.288-.27 5.8 8.6c-5.1 4.6-12.8 6.9-20.6 6.9-15.048 0-25.686-10.095-25.897-25.822l-.003-.478V9.4l13-9.4zM26.1 19.9c-8.2 0-11.7 6.2-12.4 11.2h24.8c-.3-4.8-3.7-11.2-12.4-11.2zm58.3 0c-8.2 0-11.8 6.2-12.4 11.2h24.8c-.3-4.8-3.7-11.2-12.4-11.2z" _fill="#000" fill-rule="nonzero"/>'
  }
})
